module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_NL-93188d3a071a4d100fe681b4426f35af.svg";